import { render, staticRenderFns } from "./ProductSalesReport.vue?vue&type=template&id=fcc9c1c8&scoped=true&"
import script from "./ProductSalesReport.vue?vue&type=script&lang=js&"
export * from "./ProductSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesReport.vue?vue&type=style&index=0&id=fcc9c1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc9c1c8",
  null
  
)

export default component.exports